import {InitPage} from "../index";

class ElcTempAgencyAssign {
    constructor() {

        $("#date_time").datepicker({
            dateFormat: "mm/dd/yy",
            onSelect: function(d,i){
                let path = $("#date_time").attr("data-path");
                if(d !== i.lastVal){
                    window.location.href =  path + "?datetime=" + d.replace(/\//g,"%2F") ;

                }
            }
        })

        $("#date_btn").on("click", function(e) {
          e.preventDefault();
          $("#date_time").click();

        });

        $("#date_btn").on("click", function(e) {
           e.preventDefault();
           $("#date_time").datepicker("show");
        });

        $(".items-list").select2({
            placeholder: "",
            allowClear: true
        });

        $("#elc_temp_agency_assign_employee_id").on("select2:select", function (e) {
            const tempAgencyId = $("#elc_temp_agency_assign_employee_id :selected").attr("data-tempagency_id");
            $("#elc_temp_agency_assign_temp_agency_id").val(tempAgencyId);
        });
    }

}

export function LoadPage() {
    InitPage("temp_agency_assigns index", () => {
        const elc_temp_agency_asign = new ElcTempAgencyAssign();
    });
}
